import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Monitor } from 'lucide-react';
import { API_BASE_URL, isProduction, isStaging } from '../../config/api';

const MonitoringDashboard: React.FC = () => {
  // Monitoring is served from the backend server at /monitoring (not /api/monitoring)
  // Extract base URL without the /api part
  const baseUrl = API_BASE_URL.replace('/api', '');
  const monitoringUrl = (isProduction || isStaging) ? `${baseUrl}/monitoring` : 'http://localhost:3001/monitoring';
  
  console.log('Monitoring Dashboard - Monitoring URL:', monitoringUrl);

  return (
    <div className="h-full -m-6" style={{ height: 'calc(100vh - 64px)' }}>
      <div className="bg-background border-b px-6 py-3 flex items-center justify-between">
        <h2 className="text-lg font-semibold">Real-Time Agent Monitoring</h2>
        <Link to="/admin/active-sessions">
          <Button variant="outline" size="sm">
            <Monitor className="h-4 w-4 mr-2" />
            View Active Sessions
          </Button>
        </Link>
      </div>
      <iframe
        src={monitoringUrl}
        className="w-full h-full border-0"
        title="PageMind Monitoring Dashboard"
        style={{ minHeight: '800px', height: 'calc(100% - 52px)' }}
      />
    </div>
  );
};

export default MonitoringDashboard;